import Regex from '../Regex'

export default class AlphaSpace extends Regex {
  get ruleName () {
    return 'alphaSpace'
  }

  passes () {
    return super.passes(/^[A-Za-zÀ-ÿ\s]+$/)
  }
}
